import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Row, Col } from 'reactstrap';
import { VehicleImage } from './VehicleImage';

export const LoadingCatalog = () => {

    return (
        <Row className="contentBlock vehicleList">

            <Col sm={4} className="detailCol" key={1}>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col>
                                &nbsp;
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row><Col>
                            <VehicleImage vehicleImagePath='' vehicleTypeImagePath='' vehicleMakeModel='' showLoadingSymbol={true} />
                            <Row className="stickToBottom">
                                <Col sm={6} className="text-align-center details">&nbsp;</Col>
                                <Col sm={6} className="text-align-center details">&nbsp;</Col>
                            </Row>
                        </Col></Row>
                    </CardBody>
                    <CardFooter>
                        &nbsp;
                    </CardFooter>
                </Card>
            </Col>
            <Col sm={4} className="detailCol" key={2}>
                <Card key={2}>
                    <CardHeader>
                        <Row>
                            <Col>
                                &nbsp;
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row><Col>
                            <VehicleImage vehicleImagePath='' vehicleTypeImagePath='' vehicleMakeModel='' showLoadingSymbol={true} />
                            <Row className="stickToBottom">
                                <Col sm={6} className="text-align-center details">&nbsp;</Col>
                                <Col sm={6} className="text-align-center details">&nbsp;</Col>
                            </Row>
                        </Col></Row>
                    </CardBody>
                    <CardFooter>
                        &nbsp;
                    </CardFooter>
                </Card>
            </Col>
            <Col sm={4} className="detailCol" key={3}>
                <Card key={3}>
                    <CardHeader>
                        <Row>
                            <Col>
                                &nbsp;
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Row><Col>
                            <VehicleImage vehicleImagePath='' vehicleTypeImagePath='' vehicleMakeModel='' showLoadingSymbol={true} />
                            <Row className="stickToBottom">
                                <Col sm={6} className="text-align-center details">&nbsp;</Col>
                                <Col sm={6} className="text-align-center details">&nbsp;</Col>
                            </Row>
                        </Col></Row>
                    </CardBody>
                    <CardFooter>
                        &nbsp;
                    </CardFooter>
                </Card>
            </Col>
        </Row>

    );
}